// @mui
import UploadIcon from '@mui/icons-material/Upload';
import { Typography, Box } from '@mui/material';

export function BlockContent(): JSX.Element {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      ml={2}>
      <Box>
        {/* {file ? (
          <div>
            {file?.name && (
              <Typography variant="subtitle2">{file?.name}</Typography>
            )}
            {file?.size && (
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {fData(file?.size)}
              </Typography>
            )}
          </div>
        ) : (
          <>
            <Typography variant="subtitle2" component="span">
              Drag & drop files or{' '}
              <Typography
                variant="subtitle2"
                sx={{ color: 'primary.main', display: 'inline' }}>
                Browse
              </Typography>
            </Typography>{' '}
          </>
        )} */}
      </Box>
      <Box display="flex" alignItems="center">
        <UploadIcon sx={{ color: 'primary.main', fontSize: '14px' }} />
        <Typography
          variant="subtitle2"
          component="span"
          fontSize="14px"
          sx={{ color: 'primary.main', ml: 0.5 }}>
          Upload
        </Typography>
      </Box>
      {/* <Typography gutterBottom variant="subtitle2">
        Drag & drop files or{' '}
        <Typography
          variant="subtitle2"
          component="span"
          sx={{ color: 'primary.main' }}>
          Browse
        </Typography> */}
      {/* </Typography> */}
      {/* <Button startIcon={<UploadIcon />} >Upload</Button> */}
      {/* <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {`Supported formats: ${supportedFormats ? supportedFormats : 'JPEG, PNG, GIF'}`}
      </Typography> */}
    </Box>
  );
}
